import { reactive } from '@/core/reactive/reactive';
import { ReactiveConfig } from '@/core/reactive/config';

export const render = reactive.configure(ReactiveConfig).render;
